import { render, staticRenderFns } from "./SchoolCreateLocationInfo.vue?vue&type=template&id=6e760790&"
import script from "./SchoolCreateLocationInfo.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreateLocationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports